import { 
    Fragment, 
    useState, 
    useEffect 
} from 'react'
import {
    Checkbox,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    Switch,
    FormControl,
    FormControlLabel,
    Autocomplete,
    Button,
    Link,
    Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { styled } from '@mui/material/styles';
import { 
    formatMoney, 
    phoneMask, 
    stringToFloat, 
    objectGet, 
    validateEmail,
    validatePhone
} from '../helpers/Common'
import { SimuladorBeneficiosFAQ } from '../data/simulador-beneficios-faq'
import { API } from '../helpers/API'
import Tooltip from '../blocks/Tooltip'
import PerguntasFrequentes from '../blocks/PerguntasFrequentes'
import FieldUfCidade from '../forms/FieldUfCidade'
import LoaderMask from '../helpers/LoaderMask';

const MarchaDosPrefeitos = (props) => {

    const navigate = useNavigate();
    
    const { executeRecaptcha } = useGoogleReCaptcha();

    const foto = require('../../assets/images/foto-01.png');

    const mask = new LoaderMask();
    const ocupacoes = [
        {
            id: 'assessor',
            text: 'Assessor'
        },
        {
            id: 'prefeito',
            text: 'Prefeito'
        },
        {
            id: 'vereador',
            text: 'Vereador'
        },
        {
            id: 'outros',
            text: 'Outros'
        }
    ];
    const initialValues = {
        campanha: 'marchaprefeitos',
        nome: '',
        email: '',
        telefone: '',
        uf: '',
        cidade: '',
        ocupacao: '',
        complementar: false,
        termos: false
    };
    
    const [values, setValues] = useState(structuredClone(initialValues))
    const [errors, setErrors] = useState({
        nome: false,
        email: false,
        telefone: false,
        uf: false,
        cidade: false,
        termos: false
    });
    const [ocupacao, setOcupacao] = useState( '' );
    const [honeypot, setHoneypot] = useState( '' );
    const [error, setError] = useState( false );
    const [success, setSuccess] = useState( false );

    const getShowValue = ( field ) => {
        return showValues[field];
    }

    const bindChange = event => {

        let { name, value } = event?.target !== undefined ? event.target : event;

        // Phone mask
        if( name === 'telefone' && value !== '' ){
            value = phoneMask( value, event.nativeEvent.data );
        }

        // Keep values
        setValues(prev => ({
            ...prev,
            [name]: value
        }));

        // Validate field
        validate( name, value )

    };

    const validateOne = ( field, value = false ) => {

        // Value
        if( !value ) value = objectGet( values, field );

        // Trim value
        value = typeof value === 'string' ? value.trim() : value;
        
        // Required text
        const require = field === 'termos' ? 'Concorde com os termos para enviar' : 'Campo obrigatório';
        
        // Compare value
        const compare = !value ? objectGet( values, field ) : value;
        
        // Required
        if( !compare ){
            return require;
        }
        // Nome
        else if( field === 'nome' && compare.split( ' ' ).length < 2 ){
            return 'Informe o sobrenome';
        }
        // E-mail
        else if( field === 'email' && !validateEmail( value ) ){
            return 'E-mail inválido';
        }
        // Phone
        else if( field === 'telefone' && !validatePhone( value ) ){
            return 'Número inválido';
        }
        else {
            return false
        }

    }

    const validate = ( field, value ) => {

        const fvalid = validateOne( field, value )

        setErrors(prev => ({
            ...prev,
            [field]: fvalid
        }));

    }

    const bindBlur = ( field, value ) => {
        
        // Value
        if( !value ){
            value = objectGet( values, field );
        }
        
        // Validate
        const fvalid = validateOne( field, value )

        // Keep
        setErrors(prev => ({
            ...prev,
            [field]: fvalid
        }));

    }

    const validateAll = () => {

        const newErrors = {}
        for( const fkey of Object.keys( errors ) ){
            newErrors[ fkey ] = validateOne( fkey );
        }

        // Set new validation
        setErrors(prev => ({
            ...prev,
            ...newErrors
        }));

        return !Object.values(newErrors).find(error => error !== false);

    }

    const defaulError = 'Falha ao enviar o formulário. Tente novamente!';
    const checkSubmit = async ( event ) => {

        event.preventDefault();        
        setSuccess( false )

        if( !validateAll() ){

            setError( defaulError );
        
        }
        else {

            mask.open();
            try {

                values.token = await executeRecaptcha( 'lead' );
                const response = await API.Prefeitos.sendLead( values );
                if( !response || !response?.data || response.data.status == 'error' ){
                                        
                    console.info('response');
                    console.log(response);

                    if( !response.data.errors ){
                        setError( !response?.data?.message ? defaulError : response.data.message );
                    }
                    else {
                        setError( false )
                    }

                    if( response.data.errors ){
                        setErrors(prev => ({
                            ...prev,
                            ...response.data.errors
                        }));
                    }

                }
                else {

                    setError( false );
                    setSuccess( true );
                    setValues( initialValues );
                    setTimeout(() => {
                        navigate( '/' ); 
                    }, 5000 );

                }

            }
            catch( error ){
                setError( defaulError );
            }
            finally {
                mask.close();
            }
                
                
        }

        showMessage();

    };

    const showMessage = () => {
        const message = document.querySelector( '#form-report' );
        message.scrollIntoView({ behavior: 'smooth' });
    }

    const fieldError = ( key ) => {
        return objectGet( errors, key, '&nbsp' );
    }

    const fieldClass = ( key ) => {
        return objectGet( errors, key ) ? 'error' : '';
    }

    const BootstrapButton = styled(Button)({
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: 32,
        fontWeight: 800,
        width: '100%',
        padding: '10px 24px',
        border: '1px solid',
        lineHeight: 1.5,
        backgroundColor: '#0060A9',
        borderColor: '#0060A9',
        fontFamily: [
            'BB Titulo',
            'Arial',
            '-apple-system'
        ].join(','),
        '&:hover': {
            backgroundColor: '#0069d9',
            borderColor: '#0062cc',
            boxShadow: 'none',
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#0062cc',
            borderColor: '#005cbf',
        },
        '&:focus': {
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
        },
        '@media (max-width: 480px)': {
            fontSize: '24px',
            lineHeight: '150%',
            padding: '13px 24px',
        },
    });

    const commonProps = {
        variant: "outlined",
        sx: {
            '& .MuiInputLabel-root': {
                '& fieldset': {
                    borderColor: '#FF0000'
                },
                fontSize: '18px'
            },
            '& .MuiInputBase-input': {
                height: '56px',
                paddingTop: '12px',
                paddingBottom: '12px',
                fontSize: '16px',
                boxSizing: 'border-box'
            },
            '& .MuiInputLabel-shrink': { fontSize: '18px' },
            '& .MuiOutlinedInput-root legend': { fontSize: '1.35em' }
        }
    }

    const inputStyle = {
        '& .MuiInputLabel-root': { fontSize: '18px' },
        '& .MuiInputBase-input': {
            height: '38px',
            paddingTop: '0',
            paddingBottom: '0',
            fontSize: '16px',
            boxSizing: 'border-box'
        },
        '& .MuiInputLabel-shrink': { fontSize: '18px' },
        '& .MuiOutlinedInput-root legend': { fontSize: '1.35em' }
    }

    return (
        <section id="marcha-dos-prefeitos">

            <div id="form-report" className='message'>
                {( error || success ) &&
                <div>
                    
                    {error && 
                    <em>{error}</em>}
                    
                    {success && 
                    <Fragment>
                        <em>Agradecemos o contato. Seus dados estão protegidos conforme nossos padrões de segurança e privacidade.</em>
                        <em><strong>Aguarde...</strong> <br /> Você será redirecionado para a página do <strong>BB Prev Brasil</strong> em 5 segundos.</em>
                    </Fragment>}
                
                </div>}
            </div>

            <header>
                <h1>BBPREV BRASIL</h1>
            </header>
            <form className="bottom">

                <div className='name-tel'>

                    <div className={fieldClass('nome')}>
                        <TextField
                            label="Nome Completo*"
                            name="nome"
                            value={values.nome}
                            onChange={bindChange}
                            onBlur={() => { bindBlur( 'nome' ) }}
                            error={errors.nome}
                            fullWidth
                            {...commonProps}
                        />
                        <em className={fieldClass('nome')}>{fieldError('nome')}</em>
                    </div>

                    <div className={fieldClass('email')}>
                        <TextField
                            label="E-mail*"
                            name="email"
                            onChange={bindChange}
                            onBlur={() => { bindBlur( 'email' ) }}
                            value={values.email}
                            error={errors.email}
                            slotProps={{ htmlInput: { maxLength: 254 } }}
                            fullWidth
                            {...commonProps}
                        />
                        <em className={fieldClass('email')}>{fieldError('email')}</em>
                    </div>

                    <div className={fieldClass('telefone')}>
                        <TextField
                            label="Whatsapp*"
                            name="telefone"
                            onChange={bindChange}
                            onBlur={() => { bindBlur( 'telefone' ) }}
                            value={values.telefone}
                            error={errors.telefone}
                            slotProps={{ htmlInput: { maxLength: 15 } }}
                            fullWidth
                            {...commonProps}
                        />
                        <em className={fieldClass('telefone')}>{fieldError('telefone')}</em>
                    </div>
                </div>

                <FieldUfCidade
                    value={values}
                    onChange={bindChange}
                    onBlur={bindBlur}
                    inputStyle={inputStyle}
                    errors={errors}
                />

                <Autocomplete
                    name="ocupacao"
                    options={ocupacoes}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.text}
                    isOptionEqualToValue={(option, value) => option.text === value.text}
                    value={ocupacoes.find(o => o.id === values.ocupacao) || null}
                    onChange={(event, newValue) => {
                        setValues({
                            ...values,
                            ocupacao: newValue?.id || ''
                        });
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Ocupação"
                            variant="outlined"
                            sx={inputStyle}
                        />
                    )}
                    slotProps={{
                        paper: {
                            sx: { '& .MuiAutocomplete-option': { fontSize: '14px' } }
                        }
                    }}
                />
                {values.ocupacao === 'outros' &&
                <TextField
                    label="Outra ocupação"
                    name="ocupacaodesc"
                    value={values.ocupacaodesc}
                    onChange={bindChange}
                    fullWidth
                    {...commonProps}
                />}

                <FormControlLabel
                    name="complementar"
                    value="yes"
                    className="field-switch"
                    control={
                        <Switch
                            checked={values.complementar}
                            onChange={(e) =>
                                setValues({
                                    ...values,
                                    complementar: e.target.checked
                                })
                            }
                        />
                    }
                    sx={{ alignItems: 'flex-start', '& .MuiFormControlLabel-label': { fontSize: '18px', fontWeight: '500', color: '#000', fontFamily: 'BB Texto', '@media (max-width:480px)': { fontSize: '14px', textAlign: 'center' } } }}
                    label="Possui Previdência Complementar para o Servidor?"
                    labelPlacement="top"
                />

                <div className={`${fieldClass('termos')}`}>
                    <FormControlLabel
                        name="termos"
                        value="yes"
                        className="field-switch"
                        control={
                            <Switch
                                checked={values.termos}
                                onChange={(e) =>
                                    setValues({
                                        ...values,
                                        termos: e.target.checked
                                    })
                                }
                                onBlur={() => bindBlur('termos' )}
                            />
                        }
                        label={<span>Concordo em receber informações sobre previdência para entes federativos. Meus dados serão tratados com a segurança e o rigor da <Link href="/privacidade" target="_blank">Política de Privacidade</Link> da BB Previdência*.</span>}
                        labelPlacement="top"
                        sx={{ alignItems: 'flex-start', '& .MuiFormControlLabel-label': { fontSize: '18px', fontWeight: '500', color: '#000', fontFamily: 'BB Texto', '@media (max-width:480px)': { fontSize: '14px', textAlign: 'center' } } }}
                    />
                    <em className={`termos ${fieldClass('termos')}`}>{fieldError('termos')}</em>
                </div>

                <input
                    name="website"
                    value={honeypot}
                    onChange={e => setHoneypot(e.target.value)}
                    style={{ display: 'none' }}
                    tabIndex={-1}
                    autoComplete="off"
                />

                <BootstrapButton variant="contained" disableRipple onClick={checkSubmit}>ENVIAR</BootstrapButton>


            </form>
        </section>)

}
export default MarchaDosPrefeitos